export var skeletonTextTheme = {
  baseStyle: {
    borderColor: 'neutral.dark'
  }
};
//# sourceMappingURL=SkeletonText.theme.js.map